<template>
  <div class="home">
    <div id="carousel" class="carousel slide" data-ride="carousel">
      <ol class="carousel-indicators"> 
          <li data-target="#carousel" data-slide-to="0" class="active"></li>
          <li data-target="#carousel" data-slide-to="1"></li>
          <li data-target="#carousel" data-slide-to="2"></li>
          <li data-target="#carousel" data-slide-to="3"></li>
      </ol>
      <div class="carousel-inner">
          <div class="carousel-item active">
              <img class="d-block w-100" src="/images/slide1.png" alt="First slide">
          </div>
          <div class="carousel-item">
              <img class="d-block w-100" src="/images/slide2.jpg" alt="Second slide">
          </div>
          <div class="carousel-item">
              <img class="d-block w-100" src="/images/slide4.jpg" alt="Third slide">
          </div>
          <div class="carousel-item">
              <img class="d-block w-100" src="/images/slide5.jpg" alt="Fourth slide">
          </div>
      </div>
      <a class="carousel-control-prev" href="#carousel" role="button" data-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="sr-only">Previous</span>
      </a>
      <a class="carousel-control-next" href="#carousel" role="button" data-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="sr-only">Next</span>
      </a>
    </div>

    <br />
    <div class="container">
      <div class="row justify-content-center">
          <router-link to="/brands/the-coffee-club"><img src="/images/coffeeclub.jpg" style="width: 100px; height:100px;" /></router-link>
          <router-link to="/brands/coffee-hit"><img src="/images/coffeehit.png" style="width: 100px; height:100px;" /></router-link>
          <router-link to="/brands/veneziano"><img src="/images/vcr.jpg" style="width: 100px; height:100px;" /></router-link>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'home'
}
</script>
